import React from 'react';
import PrintModal from "./PrintModal";

const PrintQueueColumn = () => {


    const columns = [{
        title: 'ردیف', dataIndex: 'row', className: "hidden lg:table-cell", key: 'row', render: (text, row, index) => {
            return index + 1;
        },
    },

        {
            title: 'نوع',
            dataIndex: 'type',
            key: 'type',
        },
        {
            title: 'واحد',
            dataIndex: 'branch',
            key: 'branch',
        },


        {
            title: 'تعداد', className: "hidden 2md:table-cell",
            dataIndex: 'count',
            key: 'count',
        },


        {
            title: 'تاریخ ثبت ', className: "hidden 2md:table-cell",
            dataIndex: 'createTime',
            key: 'createTime',
        },
        {
            title: 'صادر کننده ', className: "hidden 2md:table-cell",
            dataIndex: 'createBy',
            key: 'createBy',
        },
        {
            title: 'کد تایید ', className: "hidden 2md:table-cell",
            dataIndex: 'verificationCode',
            key: 'verificationCode',
        },
        {
            title: 'عملیات ', fixed: 'right', className: ' cell-fix-left',
            dataIndex: 'verificationCode',
            key: 'verificationCode',
            render: (item, row) => {
                return <>{!row.isPrinted
                    &&
                    <>

                        <PrintModal data={row}/>


                    </>}</>
            }
        },


    ];
    return [columns];
};

export default PrintQueueColumn;